import * as PIXI from "pixi.js";
import {drawRoundedRect} from "../../utils/graphics";
import {Assets} from "pixi.js";
import {getDeviceMedia, getTileDeviceMedia} from "../../utils/sizes";
import {app, events} from "../../utils/pixiApp";

const textStyle = new PIXI.TextStyle({
    fontSize: 24,
    textTransform: 'uppercase',
    fontFamily: "Montserrat",
    fontWeight: 600,
    fill: '#000',
})

const sizes = {
    width: 342,
    height: 154,
    font: 24,
}

export class ErrorModalComponent extends PIXI.Container {
    constructor() {
        super();
        this.bg = new PIXI.Graphics()

        this.bg.pivot.set(.5,.5)
        drawRoundedRect(this.bg, 0, 0, sizes.width, sizes.height, 24);
        this.bg.fill('#FFFFFF')
        this.bg.position.set( - (sizes.width / 2), - (sizes.height / 2))

        this.warningIcon = new PIXI.Sprite(Assets.get('modalWarning'))
        this.warningIcon.setSize(105,104)
        this.warningIcon.anchor.set(.5)
        this.warningIcon.position.set(sizes.width / 2, 0)

        this.text = new PIXI.Text({ text: 'Что-то пошло не так', style: {...textStyle, ...{fontSize: sizes.font}} });
        this.text.anchor.set(.5,.5)
        this.text.position.set(sizes.width / 2 , sizes.height / 2- 10)

        this.bg.addChild(this.warningIcon, this.text)
        this.buttonGroup = new PIXI.Graphics().rect(0,0,200, 40);

        this.btn = new PIXI.Sprite(Assets.get('accessReloadBtn'))
        this.btn.scale.set(.5,.5)
        this.btn.anchor.set(.5)
        this.btn.eventMode = 'static'
        this.btn.cursor = 'pointer'
        this.btn.position.set(this.bg.width / 2, sizes.height)
        this.btn.on('pointerdown', this.onClick.bind(this))
        this.bg.addChild(this.btn)

        this.addChild(this.bg)
        this.resizeView();

        events.onScreenResizeEvent(() => {
            this.resizeView();
        })

    }

    onClick() {
        window.parent.postMessage(
            JSON.stringify({
                type: 'RELOAD',
            }),
            '*',
        );
    }

    resizeView() {
        const mediaScreen = getDeviceMedia(app.screen.width)

        if(mediaScreen === 'web') {
            this.scale.set(1)
        } else {
            this.scale.set(.82)
        }
    }

}